import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { PageContext } from 'pages/Login/PageProvider';
import { Box, Button, Form, Link, MenuItem, PasswordInput, Select, Stack, Text, TextInput } from 'shell/components';

const LoginInputs = ({ country, device, errors, form, handleChange, handleClickButton, COUNTRY_OPTIONS }) => {
    const { loading } = useContext(PageContext);

    return (
        <LoginBox device={device}>
            <Stack alignItems={'center'}>
                <Text variant={'h6'} weight={'medium'}>
                    Log Into Your Account
                </Text>
            </Stack>

            <Select
                label={'Region'}
                labelId={'region-select'}
                renderValue={(selected) => {
                    return COUNTRY_OPTIONS.find(({ key }) => key === selected).value;
                }}
                value={country}
                onChange={(e) => handleChange('country', e.target.value)}
            >
                {COUNTRY_OPTIONS.map(({ key, value }) => (
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                ))}
            </Select>
            <Form
                onSubmit={() => {
                    handleClickButton('login');
                }}
            >
                <InputStack spacing={6}>
                    <TextInput
                        id={'email-input'}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        value={form.email}
                        label={'Email'}
                        onChange={(e) => handleChange('email', e.target.value)}
                        placeholder={'Enter email'}
                        required
                    />

                    <PasswordInput
                        id={'password-input'}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        value={form.password}
                        label={'Password'}
                        onChange={(e) => handleChange('password', e.target.value)}
                        placeholder={'Enter password'}
                        required
                    />
                </InputStack>
                <Stack sx={{ marginBottom: 6, width: 'fit-content' }}>
                    <Link data-cy={'forgot-password-link'} to={'/forgot-password'}>
                        Forgot your password?
                    </Link>
                </Stack>
                <Stack sx={{ marginBottom: 3 }}>
                    <Button data-cy={'login-button'} loading={loading} type={'submit'}>
                        Login
                    </Button>
                </Stack>
                <Stack alignItems={'center'}>
                    <SignUpText variant={'p3'}>
                        Don’t have an account? <Link to={'/sign-up'}>Sign up</Link>
                    </SignUpText>
                </Stack>
            </Form>
        </LoginBox>
    );
};

const LoginBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2),
    };
});

const SignUpText = styled(Text)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[700],
    };
});

export default LoginInputs;
